import React, { useContext, useState } from 'react'
import { IDriverManifestsDriver, IDriverManifestsTrip } from 'src/types/driver-manifests'

export interface IDriverManifestsProvider {
  drivers: IDriverManifestsDriver[]
  trips: IDriverManifestsTrip[]
  setDrivers: (value: IDriverManifestsDriver[]) => void
  setTrips: (value: IDriverManifestsTrip[]) => void
  isUpdated: boolean
  setIsUpdated: (value: boolean) => void
  refresh: boolean
  setRefresh: (value: boolean) => void
}

export const DriverManifestsContext = React.createContext<IDriverManifestsProvider | undefined>(undefined)

const DriverManifestsProvider = (props: any) => {
  const [drivers, setDrivers] = useState<IDriverManifestsDriver[]>([])
  const [trips, setTrips] = useState<IDriverManifestsTrip[]>([])
  const [isUpdated, setIsUpdated] = useState<boolean>(true)
  const [refresh, setRefresh] = useState<boolean>(false)

  const value = {
    drivers,
    trips,
    setDrivers,
    setTrips,
    isUpdated,
    setIsUpdated,
    refresh,
    setRefresh
  }

  return <DriverManifestsContext.Provider value={value}>{props.children}</DriverManifestsContext.Provider>
}

const useDriverManifestsContext = () => {
  const context = useContext(DriverManifestsContext)
  if (!context) {
    throw new Error('useDriverManifestsContext must be used within a DriverManifestsProvider')
  }
  return context
}

export { DriverManifestsProvider, useDriverManifestsContext }



// WEBPACK FOOTER //
// ./src/components/driver-manifests/DriverManifestsContext.tsx